export default {
  getContractSettings: state => {
    return state.contractSettings || null;
  },
  getCounterpartyGroup: state => {
    return state.contractSettings || null;
  },
};
